import { useState, useEffect } from "react"
import { useNavigate, NavLink, useMatch } from "react-router-dom"
import {
	Box,
	Button,
	Divider,
	Flex,
	IconButton,
	Image,
	Menu,
	MenuButton,
	MenuItem,
	MenuList,
	Text,
	useDisclosure,
} from "@chakra-ui/react"
import { HamburgerIcon, CloseIcon, ChevronDownIcon } from "@chakra-ui/icons"
import { query, collection, where, getDocs } from "firebase/firestore"

import { logout, db } from "./firebase"
import { teamIdDefaultIds } from "./Options/DefaultTeamIds.js"
import { ContactAgentModal } from "./Components/ContactAgentModal"
import { useTheme } from "./Contexts/ThemeContext"
import { Partners } from "./partnershipData.js"
import "./select.css"

export const ClientLoggedInNav = ({ userPlus }) => {
	const { theme } = useTheme()
	const navigate = useNavigate()
	const { isOpen, onOpen, onClose } = useDisclosure()

	const [isMobileMenuOpen, setMobileMenuOpen] = useState(false)
	const [agentInfo, setAgentInfo] = useState(null)
	const [isMenuOpen, setMenuOpen] = useState(false)

	const partner = Partners.find((p) => p.id === userPlus?.partner)

	const team =
		(userPlus?.teamId &&
			teamIdDefaultIds.find((team) => team.teamId === userPlus.teamId)) ||
		null

	const handleOpen = () => {
		setMenuOpen(!isMenuOpen)
	}

	useEffect(() => {
		const getAgentInfo = async () => {
			const q = query(
				collection(db, "publicAgentProfile"),
				where("id", "==", userPlus.agentInfo.id)
			)
			const docs = await getDocs(q)
			if (docs.docs.length === 0) {
				setAgentInfo(null)
			} else {
				setAgentInfo(docs.docs[0].data())
			}
		}
		if (userPlus !== null && userPlus !== "pending" && userPlus?.agentId) {
			getAgentInfo()
		}
	}, [userPlus])

	const logOutFromApp = async () => {
		try {
			await logout()
		} catch (error) {
			console.error("Failed to log out:", error)
		}
		navigate("/login")
	}

	return (
		<>
			<Box
				bgColor="white"
				borderBottom={"1px solid #cccccc"}
				height="70px"
				display={["none", "none", "none", "flex"]}
			>
				<Flex height="100%" width="100%">
					{userPlus?.partner &&
						userPlus?.teamId &&
						userPlus?.teamId !== "BDRE" && (
							<>
								<Image
									mt="10px"
									padding="5px 0px 5px 30px"
									h="45px"
									src={process.env.PUBLIC_URL + "/assets/Logo.svg"}
								/>

								<Divider
									orientation="vertical"
									borderColor="coolGray.400"
									borderWidth={1}
									height="40px"
									ml="20px"
									mr="10px"
									alignSelf="center"
								/>
								<Image
									src={team.logo_path}
									margin="5px 20px 5px 0px"
									h="45px"
								/>
							</>
						)}
					{!userPlus?.partner && (
						<Image
							padding="5px 30px 5px 30px"
							src={
								team
									? team.logo_path
									: process.env.PUBLIC_URL + "/assets/Logo.svg"
							}
						/>
					)}
					{userPlus?.partner &&
						(!userPlus?.teamId || userPlus?.teamId === "BDRE") && (
							<Image
								src={process.env.PUBLIC_URL + "/assets/Logo.svg"}
								alt="logo"
								padding="18px	30px 10px 30px"
								bgColor="white"
							/>
						)}
					<Flex
						width="100%"
						height="100%"
						alignItems={"center"}
						background="white"
						gap={{ base: 3, lg: 10 }}
						lineHeight="70px"
					>
						<Text
							style={{
								borderBottom: useMatch("/vendors")
									? `2px solid	${theme.colors.borderColor}`
									: "none",
							}}
						>
							<NavLink variant="navigationNavLink" to="/vendors">
								{partner ? partner.vendorNavText : "Vendors"}
							</NavLink>
						</Text>
						<Text
							style={{
								borderBottom: useMatch("/job-requests")
									? `2px solid	${theme.colors.borderColor}`
									: "none",
							}}
						>
							<NavLink variant="navigationNavLink" to="/job-requests">
								{partner ? partner.jobRequestHeader : "Job Requests"}
							</NavLink>
						</Text>
						{!userPlus?.partner && (
							<Text>
								<a
									href="https://quiploteams.com/how-it-works"
									target="_blank"
									rel="noopener noreferrer"
								>
									How it works
								</a>
							</Text>
						)}
					</Flex>
					<Flex
						alignItems="center"
						justifyContent="flex-end"
						mr="30px"
						bgColor="white"
						width="1000px"
						gap={5}
					>
						{agentInfo && (
							<Button variant="smallCta" onClick={onOpen} w="auto">
								Contact {agentInfo.name && agentInfo.name.split(" ")[0]}
							</Button>
						)}
						<Menu w="100%">
							<MenuButton as={Text} onClick={handleOpen} w="100px">
								Account
								<ChevronDownIcon ml="3px" />
							</MenuButton>
							<MenuList>
								<MenuItem as={NavLink} to="/profile">
									Profile
								</MenuItem>
								<MenuItem>
									<Button
										onClick={() => logOutFromApp(userPlus.partner)}
										w="100%"
									>
										Log Out
									</Button>
								</MenuItem>
							</MenuList>
						</Menu>
					</Flex>
				</Flex>
			</Box>
			{isOpen && (
				<ContactAgentModal
					agentInfo={agentInfo}
					onClose={onClose}
					isOpen={isOpen}
				/>
			)}
			<Box
				bgColor="white"
				width="100%"
				justifyContent="space-between"
				display={["flex", "flex", "flex", "none"]}
			>
				{/* Mobile */}
				{userPlus?.partner &&
					userPlus?.teamId &&
					userPlus?.teamId !== "BDRE" && (
						<Box w="100px" display="flex">
							<Image
								mt="5px"
								padding="5px 0px 5px 30px"
								h="45px"
								src={process.env.PUBLIC_URL + "/assets/Logo.svg"}
							/>

							<Divider
								orientation="vertical"
								borderColor="coolGray.400"
								borderWidth={1}
								height="20px"
								ml="10px"
								mr="10px"
								alignSelf="center"
							/>
							<Image src={team?.logo_path} mr="20px" h="45px" mt="5px" />
						</Box>
					)}
				{userPlus?.partner &&
					(!userPlus?.teamId || userPlus?.teamId === "BDRE") && (
						<Image
							src={process.env.PUBLIC_URL + "/assets/Logo.svg"}
							alt="logo"
							padding="18px	30px 10px 30px"
							bgColor="white"
						/>
					)}
				{(userPlus?.userType === "TC" || !userPlus?.partner) && (
					<Image
						padding="5px 30px 5px 30px"
						src={
							team
								? team.logo_path
								: process.env.PUBLIC_URL + "/assets/Logo.svg"
						}
					/>
				)}
				<IconButton
					aria-label="Open Menu"
					size="xxl"
					bgColor="white"
					marginRight="18px"
					icon={<HamburgerIcon w={7} h={7} />}
					onClick={() => setMobileMenuOpen(true)}
					display={["flex", "flex", "flex", "none"]}
				/>

				<Flex
					w="100vw"
					display={isMobileMenuOpen ? "flex" : "none"}
					bgColor="gray.50"
					zIndex={20}
					h="100vh"
					pos="fixed"
					top="0"
					left="0"
					overflowY="auto"
					flexDir="column"
				>
					<Flex justify="flex-end">
						<IconButton
							mt={2}
							mr={2}
							aria-label="Open Menu"
							size="lg"
							bgColor="background"
							icon={<CloseIcon />}
							onClick={() => setMobileMenuOpen(false)}
						/>
					</Flex>
					<Flex flexDir="column" align="center">
						<NavLink to="/vendors" onClick={() => setMobileMenuOpen(false)}>
							<Button variant="ghost" aria-label="Vendors" my={5} w="100%">
								{partner ? partner.vendorNavText : "Vendors"}
							</Button>
						</NavLink>
						<NavLink
							to="/job-requests"
							onClick={() => setMobileMenuOpen(false)}
						>
							<Button variant="ghost" aria-label="Job Requests" my={5} w="100%">
								{partner ? partner.jobRequestHeader : "Job Requests"}
							</Button>
						</NavLink>
						{!userPlus?.partner && (
							<Button
								as="a"
								href="https://quiploteams.com/how-it-works"
								onClick={() => setMobileMenuOpen(false)}
								target="_blank"
								rel="noopener noreferrer"
								variant="ghost"
								aria-label="How it works"
								my={5}
								w="100%"
							>
								How it works
							</Button>
						)}

						<NavLink onClick={logOutFromApp}>
							<Button variant="ghost" aria-label="Log Out" my={5} w="100%">
								Log Out
							</Button>
						</NavLink>
					</Flex>
				</Flex>
			</Box>
		</>
	)
}
